import { IComponent } from 'components/general/types/power';
import { ISurface } from 'components/general/types/spacecraft';

export const isCooler = (e: IComponent | ISurface) => {
  return 'type' in e && e.type === 'Cooler';
};
